export default {
  ND11_2020: 'CashInBankConfirmation',
  DongThap: 'CashInBankConfirmation_ND112020_DongThap',
};
